/* Arklavo "Edit design" — move the line back into the designer (GoKickflip untouched).
 * On click: remove the cart line, then continue to the PDP where the designer opens
 * the saved design. Re-adding from the designer creates the single, edited line.
 * No polling, no background swaps, no duplicate ever appears.
 * If the removal call fails, navigation proceeds anyway (worst case: the customer
 * removes the old line themselves — never a blocked click).
 */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a.ark-edit[data-ark-edit-key]') : null;
    if (!a) return;
    e.preventDefault();
    var dest = a.href;
    var done = false;
    var go = function () { if (!done) { done = true; window.location.href = dest; } };
    setTimeout(go, 1500); /* never leave the click hanging */
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: a.getAttribute('data-ark-edit-key'), quantity: 0 })
    }).then(go, go);
  }, true);
})();
